import { jsx as _jsx } from "react/jsx-runtime";
import StyledMaterialSymbolIcon from "../../../StyledMaterialSymbolIcon";
import iconAriaLabels from "../../icon-aria-labels";
const Restart = (props) => (_jsx(StyledMaterialSymbolIcon, Object.assign({}, props, { children: _jsx("span", Object.assign({ role: "img", "aria-label": iconAriaLabels.Restart }, { children: "restart_alt" })) })));
export default Restart;
